<template>
  <div>
    <div class="tab-pane-body-intro">
      <el-form ref="courseIntroForm" :model="courseInfo" :rules="courseIntroRules" label-position="right">
        <el-form-item label="" prop="pc_detail_intro">
          <el-tabs v-model="activeName" type="card">
            <el-tab-pane name="pc_detail">
              <span slot="label"><i class="red-star">*</i> PC详情</span>
              <ApeEditor name="editor" :initHtml="pcDetailIntro" @handleTinymceInput="handlePcTinymceInput" :editorHeight="480"></ApeEditor>
            </el-tab-pane>
            <el-tab-pane label="移动详情" name="app_detail">
              <ApeEditor name="editor" :initHtml="appDetailIntro" @handleTinymceInput="handleAppTinymceInput" :editorHeight="480"></ApeEditor>
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
      </el-form>  
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import ApeEditor from '@/components/ApeEditor' 
import { mapGetters } from 'vuex'

export default {
  components: {
    ApeEditor
  },
  props: {
    // 课程信息
    courseInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  // 定义属性
  data() {
    return {
      activeName: 'pc_detail',
      // pc课程详情
      pcDetailIntro: '',
      // app课程详情
      appDetailIntro: '',
      // 课程介绍规则
      courseIntroRules: {
        pc_detail_intro: [
          {required: true, message: '输入课程详情', trigger: 'blur' },
        ],
      },     
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters(['userPermissions','buttonStyle'])
  },
  // 方法集合
  methods: {
    // 处理编辑器内容输入
    handlePcTinymceInput(val) {
      this.courseInfo.pc_detail_intro = val
    },
    // 处理编辑器内容输入
    handleAppTinymceInput(val) {
      this.courseInfo.app_detail_intro = val
    },
    // 课程详情表单验证
    formValidate() {
      this.$refs['courseIntroForm'].validate((valid) => {
        if (valid) {
          this.$emit('formSubmit',this.courseInfo)
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.pcDetailIntro = this.courseInfo.pc_detail_intro
    this.appDetailIntro = this.courseInfo.app_detail_intro
  }
}
</script>

<style lang='stylus' scoped>
  .tab-pane-body-intro
    padding 16px 32px 16px 16px
    margin-bottom 48px
    .red-star
      color #ff0000
      font-style normal
</style>